var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrescription(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1176_1189)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0127 43.8456H3.20821V7.48586H12.8329V9.62467H21.3881V7.48586H31.0127V14.0841L34.2209 10.8759V4.23487H21.3881C21.356 1.89288 19.4525 3.05176e-05 17.1105 3.05176e-05C14.7685 3.05176e-05 12.8649 1.89288 12.8329 4.23487H0V47.0538H34.2209V25.4839L31.0127 28.6922V43.8456ZM42.7762 5.34705L40.1027 8.02056L44.3803 12.2982L47.0538 9.62467L42.7762 5.34705ZM25.6657 22.4575L23.5269 28.874L29.9433 26.7351L25.6657 22.4575ZM26.7351 21.3881L31.0127 25.6657L43.3109 13.3676L39.0333 9.08997L26.7351 21.3881ZM9.62464 24.5963H13.9023V20.3187H18.1799V16.0411H13.9023V11.7635H9.62464V16.0411H5.34702V20.3187H9.62464V24.5963ZM7.48583 35.2904H5.34702V37.4292H7.48583V35.2904ZM28.8739 35.2904H9.62464V37.4292H28.8739V35.2904ZM7.48583 31.0128H5.34702V33.1516H7.48583V31.0128ZM28.8739 31.0128H9.62464V33.1516H28.8739V31.0128ZM5.34702 41.7068H7.48583V39.568H5.34702V41.7068ZM28.8739 39.568H9.62464V41.7068H28.8739V39.568Z",
    fill: "#0B5ED7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1176_1189"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.0538,
    height: 47.0538,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrescription);
export default __webpack_public_path__ + "static/media/prescription.0f55181a59e3bc5250b8dcd2fc96b2c0.svg";
export { ForwardRef as ReactComponent };